<template>
  <div>
    <title-row
      title="Tárolók"
      :breadcrumb-items="[
        { text: 'Eszközök', to: { name: 'AssetList' } },
        { text: 'Tárolók', disabled: true }
      ]">
      <template #buttons>
        <title-row-button
          v-if="hasRight('KEY_WRITE')"
          :to="{ name: 'NewAssetCabinet' }"
          title="Hozzáadás">
          <v-icon dark>mdi-plus</v-icon>
          Új tároló
        </title-row-button>
      </template>
    </title-row>

    <v-expansion-panels
      class="mb-4 rounded-xl overflow-hidden"
      :mandatory="!!Object.values(search).find((e) => e !== '')"
      flat>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left>mdi-magnify</v-icon>
            Keresés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2">
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                clearable
                hide-details />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card flat :loading="loading" class="rounded-xl">
      <v-data-table
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
        :item-class="itemClass">
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('KEY_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-sm mr-1"
            :to="{ name: 'AssetCabinetEditor', params: { id: item.id } }"
            title="Szerkesztés">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('KEY_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-sm ma-1"
            @click="deleteAssetCabinet(item)"
            title="Törlés">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'AssetCabinetList',
      fetchItems: this.fetchAssetCabinets,
      dataTable: {
        options: {
          sortBy: ['asset_cabinet_name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'asset_cabinet_name' },
          { text: 'Épület', value: 'building_name' },
          { text: 'Szint', value: 'building_level_name' },
          { text: 'Megjegyzés', value: 'remark', sortable: false },
          { text: 'Kulcsok száma', value: 'assets_count', sortable: false },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        name: '',
      },
      groups: [],
      searchTimeout: null,
    };
  },

  methods: {
    parseSearchQueries() {
      return {
        name: this.$route.query.name,
        building_name: this.$route.query.building_name,
      };
    },

    async deleteAssetCabinet(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> kulcsszekrény törlésére készül! Folytatja?`,
        title: 'Figyelem',
      });

      if (confirm) {
        try {
          this.loading = true;
          const response = await this.$http.post(`asset-cabinets/delete/${item.id}`);
          this.fetchAssetCabinets();
          if (response.status === 'OK') {
            this.$dialog.notify.info('A kulcsszekrény törölve');
          }
        } catch (e) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      }
    },

    async fetchAssetCabinets() {
      this.loading = true;
      try {
        const response = await this.$http.post('asset-cabinets/list', this.postData);
        this.dataTable.items = response.asset_cabinets;
        this.dataTable.itemsLength = response.asset_cabinets_count;
        this.dataTable.options.page = Number(this.$route.query.page) || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
        building_name: this.search.building_name || '',
      };
    },
  },
};
</script>
